import camelCase from 'lodash-es/camelCase';
import isObject from 'lodash-es/isObject';

import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode, SupportedClassName } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicDetails } from 'lcc-state/interfaces';
import { TopicWidgetProperties, TableAttrs } from 'book-widgets/interfaces';
import { Title } from './title';
import { TableTgroup } from './table-tgroup';

import { knownClasses } from './table-util';

import css from '@holmescorp/book-widgets/css/topicpage.m.css';

export { ColSpec, ColSpecMap } from './table-tgroup';

const factory = create({ theme }).properties<TopicWidgetProperties>();

export const Table = factory(({ properties, middleware: { theme } }) => {
	const { topicdata } = properties();
	const themeCss = theme.classes(css);
	const data: TopicDetails = topicdata as any;
	const { attributes = {} as TableAttrs } = data;

	const jsonkids = data.children!;
	const titleobj = jsonkids.find((kid) => isObject(kid) && 'title' in kid);
	const tgroups = jsonkids.filter((kid) => isObject(kid) && 'tgroup' in kid);
	const id = attributes.id;
	let outputclass = attributes.outputclass || null;
	if (outputclass) {
		outputclass = camelCase(outputclass);
		if (!knownClasses.has(outputclass)) {
			outputclass = null;
		}
	}
	const renderedTgroups = tgroups.map((tgroup) => {
		return w(TableTgroup, { tgroup: tgroup.tgroup, tableattrs: attributes });
	});

	return v('figure', { id, classes: [themeCss.figure, outputclass && (themeCss as any)[outputclass]] }, [
		titleobj ? w(Title, { title: titleobj, insection: true }) : null,
		...renderedTgroups
	]);
});
